/**
 * 系统管理 菜单管理
 */
<template>
  <div class="main">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>考核数据</el-breadcrumb-item>
      <el-breadcrumb-item>订购会信息</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
        <el-form class="user-search">
          <el-form-item>
            <el-button size="small" type="primary" @click="goback">返回</el-button>
          </el-form-item>
        </el-form>
		 <div class="titlelist" v-if="list.cancelPerson"><div class="icons"></div>作废人信息</div>
		 
		 <div class="listout" v-if="list.cancelPerson">
		 	<div class="list">
		 		<div class="listleft">作废人：{{list.cancelPerson}}</div>
		 	</div>
			<div class="list">
				<div class="listleft">作废理由：{{list.cancelReason}}</div>
			</div>
		 	<div class="list">
		 		<div class="listleft">作废时间：{{list.cancelTime}}</div>
		 	</div>
		 	
		 </div>
		 
		 
		 
        <div class="titlelist"><div class="icons"></div>订购会信息</div>
		<div class="listout">
			<div class="list">
				<div class="listleft">订购会名称：{{list.name}}</div>
			</div>
			<div class="list">
				<div class="listleft">订购会内容：{{list.content}}</div>
			</div>
			<div class="list">
				<div class="listleft">创建人：{{list.creator}}</div>
			</div>
			<div class="list">
				<div class="listleft">创建时间：{{list.createTime}}</div>
			</div>
			
			
		</div>
		
		
		
		
		
		
		<div class="titlelist"><div class="icons"></div>完成信息</div>
		<div class="listout">
			<div class="list">
				<div class="listleft">执行时间：{{list.eventTime}}</div>
			</div>
			<div class="list">
				<div class="listleft">团购会地点：{{list.province}}{{list.city}}{{list.county}}{{list.address}}</div>
			</div>
			<div class="list">
				<div class="listleft">参会人数：{{list.attendance}}</div>
			</div>
			<div class="list">
				<div class="listleft">销售数量：{{list.salesQuantity}}</div>
			</div>
			
		</div>
		
		<div class="listout">
			<div class="list">
				<div class="listleft">订购会形式：{{list.meetingForm}}</div>
			</div>
			<div class="list">
				<div class="listleft">备注：{{list.remark}}</div>
			</div>
			<div class="list">
				<div class="listleft">填写时间：{{list.finishTime}}</div>
			</div>
			
			
		</div>
		
		<div class="listout">
			<div class="listleft">活动图片</div>
		</div>
		<div class="listout">
			<div class="lists">
				  <div class="imglist" v-for="(item,index) in resultFilelist">
					  <img :src="item.url" @click="clickimg(item.fileTemporaryUrl)" />
				  </div>
			</div>
			
		</div>
		
		<div class="listout">
			<div class="lists">
				  <div class="imglist" v-for="(item,index) in resultFilelist1">
					  <video :src="item.url"></video>
					  
				  </div>
			</div>
			
		</div>
		
		<el-dialog
		  title=""
		  :visible.sync="centerDialogVisible"
		  width="70%"
		  center>
		  <img class="imgUrls" :src="imgUrls"/>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="centerDialogVisible = false">取 消</el-button>
		    <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
		  </span>
		</el-dialog>
		
		
      </div>
    </template>

    <script>
	// 导入请求方法
	import { uploadFile } from '../../api/axiosFun';
    import {
      getSubscriptMeetingById,
      } from '../../api/knowledgeFun'
    import Pagination from '../../components/Pagination'

  
    import {evaluateUpload }from '@/api/auth';
    import { setCookie, getCookie, delCookie } from '../../utils/util'



    export default {
      data() {
        return {
          loading: false, //是显示加载
          list:[],
		  resultFilelist:[],
		  resultFilelist1:[],
		  lists:[],
		  fileList: [],
		  centerDialogVisible: false,
		  imgUrls:''
         
        }
      },
      // 注册组件
      components: {
        Pagination
      },

      /**
       * 数据发生改变
       */
      watch: {},

      /**
       * 创建完毕
       */
      created() {
        //this.getData(this.formProInfo)

      },
      mounted(){
		  this.id = this.$route.query.id
		  this.handleEdit()
		  
      },
      beforeDestroy(){
        // document.removeEventListener("paste",this.handlePaste);
      },
      /**
       * 里面的方法只有被调用才会执行
       */
      methods: {
		clickimg(e){
			this.imgUrls = e
			this.centerDialogVisible  = true
		},
		  //显示编辑界面
		  handleEdit: function() {
		    let _this = this
		   
		   getSubscriptMeetingById(this.id).then(res => {
		       console.log(res)
		       this.loading = false
		       if (res.success == false) {
		         this.$message({
		           type: 'info',
		           message: res.msg+'TraceId:'+res.traceId
		         })
		       } else {
		         console.log(res)
		         this.list = res.data
				  this.resultFilelist = []
				  this.resultFilelist1 = []
				 if(res.data.pictureInfoList){
					 res.data.pictureInfoList.map((item,index)=>{
					     this.resultFilelist.push({
					       url:item.fileTemporaryUrl,
					       fileTemporaryUrl:item.fileTemporaryUrl,
					       fileId:item.fileId,
					       name: item.ossFile.fileName,
					       mediaObjInfo:item
					     })
					     
					 })
				 }
				 if(res.data.videoInfoList){
					 res.data.videoInfoList.map((item,index)=>{
						 this.resultFilelist.push({
						   url:item.fileTemporaryUrl,
						   fileTemporaryUrl:item.fileTemporaryUrl,
						   fileId:item.fileId,
						   name: item.ossFile.fileName,
						   mediaObjInfo:item
						 })
						 
					 })
				 }
					 
				 }
				 
		   		  
		         
		     })
		   
		   
		  },
		 
		//编辑
		goback() {
			this.$router.push({ path: '/meeting'})
		 
		},
		

      }
    }
    </script>

    <style scoped>
	.listout{
		width: 96%;
		display: flex;
		margin: 0 auto;
		margin-top: 20px;
		font-size: 14px;
	}
	.list{
		width: 25%;
		height: 20px;
		line-height: 20px;
		text-align: left;
	}
	.lists{
		width: 100%;
		display: flex;
	}
	.imglist{
		margin-right: 10px;
	}
	.titlelist{
		margin: 0 auto;
		height: 30px;
		text-align: left;
		line-height: 30px;
		margin-top: 40px;
		padding-left: 10px;
		width: 96%;
		position: relative;
	}
	.icons{
		height: 22px;
		width: 4px;
		border-radius: 10px;
		background-color: #000;
		position: absolute;
		left: 0;
		top: 4px;
	}
    .user-search {
		position: absolute;
		top: 20px;
		right: 0px;
		width: 100px;
    }
	.user-searchs {
	  margin-top: 20px;
	}
    .userRole {
      width: 100%;
    }
    .main{
    	background-color: #fff;
    	padding: 30px;
    	border-radius: 10px;
    }
    /* .avatar-uploader{
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
    } */
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  
  .editForm{
	  margin: 0 auto;
	  margin-top: 30px;
	  width: 600px;
	  
  }
  .el-select{
	  width: 100%;
  }
  .dialog-footer{
	  margin: 0 auto;
	  margin-top: 30px;
	  width: 480px;
	  padding-left: 120px;
  }
  .title{
	  width: 100%;
  }
  .tableout{
	  width: 95%;
	  height: 120px;
	  border: 1px solid #d9d9d9;
	  border-radius: 5px;
	  font-size: 14px;
  }
  .tablelist{
	  width: 100%;
	  height: 40px;
	  line-height: 40px;
	  text-align: center;
	  
  }
  .tablelists{
  	  width: 100%;
  	  height: 40px;
  	  line-height: 40px;
  	  text-align: center;
  	  display: flex;
  	  
  }
  .tabletitle{
	  width: 100%;
	  height: 40px;
	  line-height: 40px;
	  text-align: center;
	  display: flex;
	  background-color: #ebe8e8;
  }
  .tabileleft{
	  width: 50%;
	  text-align: center;
	  
  }
  .tabileright{
	  width: 50%;
	  text-align: center;
  }
  .liststable{
  	width: 25%;
  }
  .listouts{
  	width: 96%;
  	display: flex;
  	margin: 0 auto;
  	margin-top: 20px;
  }
  .imglist img{
	  width: 150px;
	  height: 150px;
  }
  .imgUrls{
  	  width: 100%;
  	  height: auto;
  }
    </style>





// WEBPACK FOOTER //
// src/views/guidetool/meetingadd.vue